import { useEffect } from 'react';
import { useAccountCleanup } from '@/hooks/useAccountCleanup';

export function AutoAccountCleanup() {
  const { cleanupPlaceholderAccounts } = useAccountCleanup();

  useEffect(() => {
    // Automatically clean up placeholder accounts when the component mounts
    // This runs silently in the background
    const cleanup = async () => {
      try {
        await cleanupPlaceholderAccounts();
      } catch (error) {
        // Silently fail - don't show errors for auto-cleanup
        console.log('Auto cleanup completed silently');
      }
    };

    // Run cleanup after a short delay to avoid blocking initial render
    const timer = setTimeout(cleanup, 1000);
    
    return () => clearTimeout(timer);
  }, [cleanupPlaceholderAccounts]);

  // This component doesn't render anything visible
  return null;
}